import { FuseAnimate, FuseScrollbars } from "@fuse";
import _ from "@lodash";
import { Checkbox, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import DashboardFuncionalidade from "app/Core/Components/DashboardFuncionalidade/DashboardFuncionalidade";
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import PesquisaPainel from "app/Core/Components/PesquisaPainel/PesquisaPainel";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import EmpresaPessoaApp from "app/ERP/EmpresaPessoa/EmpresaPessoaApp";
import NovoFluxoApp from "app/Workflow/MinhasTarefas/Apps/NovoFluxoApp";
import classNames from "classnames";
import MobileDetect from "mobile-detect";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/EmpresaFinanceiroActions";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    footer: {
        display: "flex",
        position: "fixed",
        right: 30,
        bottom: 50,
        zIndex: 99
    },
    tachado: {
        textDecoration: "line-through"
    },
    anotherLine: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
    }

});

const parametros = {
    filter: {
        AND: [{ "Campo": "tarefaprocessoapontamento.competencia", "Operador": ">=", "Valor": (Helpers.GetDataFirstDayMonth("usa") + " 00:00:00") },
        { "Campo": "tarefaprocessoapontamento.competencia", "Operador": "<=", "Valor": (Helpers.GetDataLastDayMonth("usa") + " 23:59:59") }
        ]
    }
};

const NewState = {
    inicio: Helpers.GetDataFirstDayMonth("usa"),
    termino: Helpers.GetDataLastDayMonth("usa"),
    idpessoaformulario: null,
    idtarefaprocesso: null,
    nome: null,
    open: null,
    selecteds: "",
    tabValue: 0,
    changeView: null,
    idtarefaprocessofaturamento: null
};

class EmpresaFinanceiroFaturamento extends XAPPComponent {

    state = { ...NewState };

    componentDidMount() {
        const xappRouteParams = this.props.match.params;
        this.props.listFaturamento(xappRouteParams, parametros.filter);
    }

    componentWillUnmount() {
        this.props.clearReducer();
        this.setState({ ...NewState });
    }

    handleChangeRadio = (event, item) => {
        var AState = this.state.selecteds.split(",");
        AState = AState.filter(value => value !== "");

        if (!this.isSelected(item.idtarefaprocessoapontamento)) {
            AState.push(item.idtarefaprocessoapontamento);
        }
        else {
            AState = AState.filter(id => id !== item.idtarefaprocessoapontamento.toString());
        }
        if (AState === null) {
            AState = [];
        }
        this.setState(_.set({ ...this.state }, event.target.name, AState.join()));
    };

    isSelected = (id) => {
        return _.findIndex(this.state.selecteds.split(","), x => (x === id)) !== -1;
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    SelectAll = (_AData) => {
        var ASelected = "";
        if (this.state.selecteds.length < 1) {
            if (!_.isUndefined(_AData) && !_.isNull(_AData)) {
                _AData.forEach(item => {
                    if (ASelected.length > 0) {
                        ASelected += ",";
                    }
                    ASelected += item.idtarefaprocessoapontamento;
                });

                this.setState(_.set({ ...this.state }, "selecteds", ASelected));
            }
        } else {
            this.setState(_.set({ ...this.state }, "selecteds", ""));
        }
    };

    getColumns = () => {
        const { selecteds, tabValue } = this.state;
        var AResponse = [];
        const data = this.getFaturamentos();
        const Columns = [
            {
                Header: () => (
                    <Checkbox
                        onClick={event => event.stopPropagation()}
                        onChange={event => this.SelectAll(data)}
                        checked={selecteds.split(",").length === Object.keys(data).length && selecteds.length > 0}
                        indeterminate={selecteds.split(",").length !== Object.keys(data).length && selecteds.length > 0}
                    />
                ),
                width: 60,
                tabValue: [0],
                Cell: row => (
                    <div className="flex items-center">
                        <Checkbox
                            type='checkbox'
                            name='selecteds'
                            disabled={row.original.idparent !== null}
                            checked={selecteds.length > 0 && this.isSelected(row.original.idtarefaprocessoapontamento)}
                            onClick={event => event.stopPropagation()}
                            onChange={event => this.handleChangeRadio(event, row.original)}
                        />
                    </div>
                )
            },
            {
                Header: "ID",
                accessor: "idtarefaprocessoapontamento",
                //width: 100,
                tabValue: [0, 1],
                className: "justify-end"
            },
            {
                Header: "Processo",
                accessor: "idtarefaprocesso",
                //width: 100,
                tabValue: [0],
                className: "justify-end"
            },
            {
                Header: "Nome",
                accessor: "processonome",
                //width: 160,
                tabValue: [0],
                className: "justify-start"
            },
            {
                Header: "Pagador",
                accessor: "nome",
                //width: 160,
                tabValue: [0],
                className: "justify-start"
            },
            {
                Header: "Valor",
                accessor: "valortotaldescricao",
                //width: 100,
                tabValue: [0, 1],
                className: "justify-end"
            },
            {
                Header: "Faturamento",
                accessor: "competenciadescricao",
                //width: 120,
                tabValue: [0, 1],
                className: "justify-end"
            },
            {
                Header: "Titulo",
                accessor: "idparent",
                //width: 100,
                tabValue: [0],
                className: "justify-end"
            },
            {
                Header: "Status",
                width: 60,
                tabValue: [0],
                Cell: row => (
                    <div className="flex items-center">
                        {row.original.idparent === null ?
                            <XAPPButton
                                type="Icon"
                                className="hover:bg-transparent"
                                iconProps={"justify-end text-grey"}
                                icon={"timer"}
                                key={"iconPending"}
                            />
                            :
                            <XAPPButton
                                type="Icon"
                                className="hover:bg-transparent"
                                iconProps={"justify-end text-green"}
                                icon={"done"}
                                key={"iconDone"}
                            />
                        }
                    </div>
                )
            }
        ];

        Columns.forEach(item => {
            if (item.tabValue.includes(tabValue)) {
                AResponse.push(item);
            }
        });
        return AResponse;
    };

    desfazerFaturamento = () => {
        const { xappRouteParams, saveFaturamento } = this.props;
        const { idtarefaprocessofaturamento } = this.state;
        saveFaturamento("DESFAZERFATURAMENTO", { idtarefaprocesso: idtarefaprocessofaturamento }, xappRouteParams, this.getFilter());
        this.setState({ idtarefaprocessofaturamento: null });
    };

    listFilter = () => {
        const xappRouteParams = this.props.match.params;
        var AFilter = this.getFilter();
        this.setState({ selecteds: "" });
        this.props.listFaturamento(xappRouteParams, AFilter);
    };

    handleLookupPessoaFormulario = (_AValue = null) => {
        var obj = this.state;
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj.idpessoaformulario = _AValue[0].idpessoaformulario;
            obj.nome = _AValue[0].nome;
            this.setState(obj);
        }
        else {
            obj.idpessoaformulario = null;
            obj.nome = null;
            this.setState(obj);
        }
    };

    getFilter = () => {
        const { xappRouteParams } = this.props;
        const form = this.state;
        var AFilter = JSON.parse(JSON.stringify(parametros.filter));
        AFilter.AND[0].Valor = form.inicio + " 00:00:00";
        AFilter.AND[1].Valor = form.termino + " 23:59:59";
        AFilter.AND.splice(2);

        if (form.idpessoaformulario !== null && form.idpessoaformulario !== "") {
            AFilter.AND.push({ "Campo": "tarefaprocessoapontamento.idpessoaformulario", "Operador": "=", "Valor": form.idpessoaformulario });
        }
        return AFilter;
    };

    canBeFilter = () => {
        const { inicio, termino, idpessoaformulario } = this.state;
        return (
            inicio !== null && inicio !== "" &&
            termino !== null && termino !== ""
        );
    };

    getFaturamentos = () => {
        const { data } = this.props;
        const { tabValue } = this.state;
        var AResponse = [];

        if (!_.isUndefined(data) && !_.isNull(data)) {
            data.map(item => {
                if ((tabValue === 0 && item.idparent === null) || (tabValue === 1 && item.idparent !== null) &&
                    _.findIndex(AResponse, { idparent: item.idparent }) < 0) {
                    AResponse.push(item);
                }
            });
        }

        return AResponse;
    };

    handleChangeTab = (event, tabValue) => {
        this.setState({ tabValue, selecteds: "" });
    };

    handleChangeView = (_AID) => {
        this.setState({ changeView: _AID });
    };

    render() {
        const { data, classes } = this.props;
        const xappRouteParams = this.props.match.params;
        const form = this.state;
        var bgColor = 0;
        return (
            <React.Fragment>
                <PesquisaPainel
                    id="faturamento"
                    anchor="left"
                    onRef={instance => this.PesquisaPainel = instance}
                >
                    <div className={"flex flex-col p-12 text-center items-center"}>
                        <EmpresaPessoaApp
                            className="mb-12"
                            xappRouteParams={xappRouteParams}
                            selected={!_.isNull(form.idpessoaformulario) ? [{ ...form, id: form.idpessoaformulario }] : []}
                            label={"Pessoa"}
                            id={"LookupFiltroAReceberEmpresaPessoa"}
                            campoid={"idpessoaformulario"}
                            camponome={"nome"}
                            onChange={this.handleLookupPessoaFormulario}
                            required={true}
                            isLookup={true}
                            multiSelect={false}
                        />
                        <TextField
                            className="mb-12"
                            id="inicio"
                            name="inicio"
                            label="Início"
                            value={form.inicio}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            className="mb-12"
                            id="termino"
                            name="termino"
                            label="Término"
                            value={form.termino}
                            onChange={this.handleChange}
                            variant="outlined"
                            type="date"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    <div className="flex p-12 gap-6">
                        <div className="flex-1" />
                        <XAPPButton
                            className="text-white"
                            label="Limpar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="close"
                            iconProps="text-20 mr-8"
                            onClick={() => this.clearFiltro()}
                        />
                        <XAPPButton
                            className="text-white"
                            label="Pesquisar"
                            type="Button"
                            variant="contained"
                            color="primary"
                            icon="search"
                            iconProps="text-20 mr-8"
                            onClick={() => this.pesquisar()}
                        />
                    </div>
                </PesquisaPainel>
                <DashboardFuncionalidade
                    funcionalidade={"faturamento"}
                    data={data}
                    agrupador={"status"}
                    //conteudo={form.tabValue === 0 ? "valortotal" : "valortotaltitulo"}
                    conteudo={"valortotal"}
                >
                    {!_.isUndefined(data) && !_.isNull(data) && data.length > 0 &&
                        <ImprimirApp
                            data={this.getFaturamentos()}
                            key="btnImprimir"
                            id="EmpresaFinanceiroFaturamento"
                            label="FATURAMENTO"
                            column={this.getColumns()}
                            className="p-6"
                            type="icon"
                            color="action"
                        />
                    }
                    {form.idtarefaprocessofaturamento !== null && form.tabValue === 1 &&
                        <XAPPButton
                            tooltip={{ "title": "Desfazer faturamento", "placement": "top" }}
                            className={"p-6"}
                            type="Icon"
                            color="action"
                            icon={"clear"}
                            onClick={(ev) => this.desfazerFaturamento()}
                        />
                    }
                    {form.selecteds.length > 0 && form.tabValue === 0 &&
                        <NovoFluxoApp
                            tooltip={{ "title": "Gerar faturamento", "placement": "top" }}
                            className={"p-6"}
                            type="Icon"
                            color="action"
                            tipo={102}
                            get={"SEL"}
                            idpessoa={this.props.xappRouteParams.empresa}
                            iconProps={"justify-center"}
                            icon={"cifrao"}
                            showDialog={true}
                            callback={this.listFilter}
                            data={form}
                            xappRouteParams={this.props.xappRouteParams}
                        />
                    }
                </DashboardFuncionalidade>
                <Tabs
                    value={form.tabValue}
                    onChange={this.handleChangeTab}
                    indicatorColor="secondary"
                    textColor="secondary"
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{
                        root: "h-32 w-full"
                    }}
                >
                    <Tab value={0} classes={{ root: "h-32" }} label="Pendente" />
                    <Tab value={1} classes={{ root: "h-32" }} label="Faturados" />
                </Tabs>
                {form.tabValue === 0 &&
                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                        <div className="w-full flex flex-col">
                            {(this.getFaturamentos().length > 0) ?
                                <ReactTable
                                    className={classNames(classes.root, "min-w-full -striped -highlight border-0")}
                                    data={this.getFaturamentos()}
                                    columns={this.getColumns()}
                                    defaultPageSize={data.length}
                                    showPagination={false}
                                />
                                :
                                <div className="flex flex-col flex-1 items-center justify-center p-16">
                                    <div className="max-w-512 text-center">
                                        <FuseAnimate delay={500}>
                                            <Typography variant="h6" color="textSecondary" className="mb-16">
                                                {"Não existem registros cadastrados!"}
                                            </Typography>
                                        </FuseAnimate>
                                    </div>
                                </div>
                            }
                        </div>
                    </FuseAnimate>
                }
                {form.tabValue === 1 &&
                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                        <div className="w-full flex flex-col">
                            <FuseScrollbars className="flex-row flex-grow overflow-x-auto">
                                <Table className="min-w-full" aria-labelledby="tableTitle">
                                    <TableHead>
                                        <TableRow
                                            className={classNames("h-32 items-center")}
                                            hover
                                            style={{ display: "table-row" }}
                                            tabIndex={-1}
                                            key={"tarefa_Header"}
                                        >
                                            <TableCell component="th" scope="row" style={{ borderBottom: "0px" }} padding={"none"}>
                                            </TableCell>
                                            <TableCell component="th" scope="row" style={{ borderBottom: "0px" }} padding={"none"}>
                                                {"Titulo"}
                                            </TableCell>
                                            <TableCell component="th" scope="row" style={{ borderBottom: "0px" }} padding={"none"}>
                                                {"Pagador"}
                                            </TableCell>
                                            <TableCell component="th" scope="row" style={{ borderBottom: "0px" }} padding={"none"}>
                                                {"Valor total"}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.getFaturamentos().map(n => {
                                            bgColor = bgColor === 0 ? 1 : 0;
                                            return (
                                                <React.Fragment>
                                                    <TableRow
                                                        className={classNames("h-32 items-center", bgColor === 1 && classes.anotherLine)}
                                                        hover
                                                        style={{ display: "table-row" }}
                                                        tabIndex={-1}
                                                        key={"tarefa_" + n.idtarefa}
                                                    >
                                                        <TableCell component="th" scope="row" style={{ borderBottom: "0px", padding: "4px 56px 4px 0px", width: "200px" }}>
                                                            <Checkbox
                                                                type='checkbox'
                                                                name='idtarefaprocessofaturamento'
                                                                checked={form.idtarefaprocessofaturamento === n.idtarefaprocessofaturamento}
                                                                onChange={event => {
                                                                    if (form.idtarefaprocessofaturamento === n.idtarefaprocessofaturamento) {
                                                                        this.setState(_.set({ ...form }, event.target.name, null));
                                                                    }
                                                                    else {
                                                                        this.setState(_.set({ ...form }, event.target.name, n.idtarefaprocessofaturamento));
                                                                    }
                                                                }}
                                                            />
                                                            {form.changeView === n.idparent ?
                                                                <XAPPButton
                                                                    type="Icon"
                                                                    className="py-8 px-24"
                                                                    onClick={() => this.handleChangeView(null)}
                                                                    icon={"minus"}
                                                                />
                                                                :
                                                                <XAPPButton
                                                                    type="Icon"
                                                                    className="py-8 px-24"
                                                                    onClick={() => this.handleChangeView(n.idparent)}
                                                                    icon={"add"}
                                                                />
                                                            }
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" style={{ borderBottom: "0px" }} padding={"none"}>
                                                            {n.idparent}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" style={{ borderBottom: "0px" }} padding={"none"}>
                                                            {n.nome}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" style={{ borderBottom: "0px" }} padding={"none"}>
                                                            {n.valortotaltitulodescricao}
                                                        </TableCell>
                                                    </TableRow>
                                                    {data.map(d => {
                                                        if (n.idparent === d.idparent) {
                                                            return (
                                                                <TableRow
                                                                    className={classNames("h-32 items-center", bgColor === 1 && classes.anotherLine)}
                                                                    hover
                                                                    style={(form.changeView === d.idparent) ? { display: "table-row" } : { display: "none" }}
                                                                    tabIndex={-1}
                                                                    key={"tarefa_" + d.idtarefaprocessoapontamento}
                                                                >
                                                                    <TableCell component="th" scope="row" style={{ borderBottom: "0px" }} padding="none">
                                                                    </TableCell>
                                                                    {this.getColumns().map(col => (
                                                                        <TableCell component="th" scope="row" style={{ borderBottom: "0px" }} padding="none">
                                                                            {col.accessor === "idtarefaprocessoapontamento" ? ("Pedido: " + d[col.accessor]) : d[col.accessor]}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            );
                                                        }
                                                    })}
                                                </React.Fragment>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </FuseScrollbars>
                        </div>
                    </FuseAnimate>
                }
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        save: Actions.save,
        listFaturamento: Actions.listFaturamento,
        saveFaturamento: Actions.saveFaturamento,
        clearReducer: Actions.clearReducer,
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroFaturamento)));
